import { useMemo, type PointerEvent } from 'react';
import { formatTimecode } from '../../core/time';
import type { Composition } from '../../core/schema';
import { usePlaybackStore } from '../../store/playbackStore';

export function TimelineRuler({ composition, zoom, labelWidth }: { composition: Composition; zoom: number; labelWidth: number }) {
  const interval = zoom >= 180 ? 0.5 : zoom >= 80 ? 1 : zoom >= 40 ? 2 : 5;
  const ticks = useMemo(() => Array.from({ length: Math.ceil(composition.duration / interval) + 1 }, (_, index) => index * interval), [composition.duration, interval]);
  const seek = (event: PointerEvent<HTMLDivElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const update = (clientX: number) => usePlaybackStore.getState().setTime(Math.max(0, Math.min(composition.duration, (clientX - rect.left) / zoom)));
    update(event.clientX);
    event.currentTarget.setPointerCapture(event.pointerId);
    const move = (moveEvent: globalThis.PointerEvent) => update(moveEvent.clientX);
    const up = () => { window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up, { once: true });
  };
  return <div className="timeline-ruler-row"><div className="ruler-corner" style={{ width: labelWidth }}>LAYERS <span>↕</span></div><div className="ruler-track" onPointerDown={seek}>{ticks.map((time) => <div key={time} className="ruler-tick" style={{ left: time * zoom }}><i /><span>{formatTimecode(time, composition.fps, false).replace(/^00:/, '')}</span><div className="minor-ticks" /></div>)}</div></div>;
}
